import _ from "lodash";
import { GridViewColumnState } from "helpers/porduct-collection-types";

export const ALLOWED_FILTER_KEYS = ["total"];

export const mergeColumns = (targetColumns: GridViewColumnState[], sourceColumns: Partial<GridViewColumnState>[]) => {
    const dict = _.keyBy(targetColumns, "colId");
    return _.map(sourceColumns, (column) => _.defaults({ ...column }, dict[column.colId]));
};

export const reorderColumnKeys = (groupedColumnsKeys: string[], orderedKeys: string[]) =>
    _.sortBy(groupedColumnsKeys, (item) => orderedKeys.indexOf(item));
